import { render } from "./ReferralDetailView.vue?vue&type=template&id=d7521896"
import script from "./ReferralDetailView.vue?vue&type=script&lang=js"
export * from "./ReferralDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__